import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Informations",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Informations"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "SCOPE compile des données administratives, des enquêtes auprès des ménages, des évaluations de l’apprentissage et des données sur le financement de l’éducation émanant de différents producteurs de données, en particulier de l’Institut de statistique de l’UNESCO, en vue d’examiner les progrès réalisés en faveur de l’ODD 4, l’objectif mondial relatif à l’éducation."
    }), "\n", _jsxs(_components.p, {
      children: ["Il complète l’ ", _jsx(_components.a, {
        href: "https://fr.unesco.org/gem-report/allreports",
        children: "édition imprimée"
      }), " du Rapport mondial de suivi sur l’éducation, en permettant aux utilisateurs d’interagir avec les données pour comprendre les réussites et les défis des pays et des régions qui s’efforcent d’atteindre les cibles. Il peut être partagé et téléchargé, et ses utilisateurs peuvent créer des images et des fichiers de données afin d’approfondir leurs connaissances, de les imprimer ou encore de les utiliser en ligne ou dans le cadre d’exposés."]
    }), "\n", _jsx(_components.h2, {
      id: "le-rapport-mondial-de-suivi-sur-léducation",
      children: "Le Rapport mondial de suivi sur l’éducation"
    }), "\n", _jsxs(_components.p, {
      children: ["Le Rapport mondial de suivi sur l’éducation est une parution indépendante sur le plan éditorial, hébergée et publiée chaque année par l’UNESCO. Selon le ", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656_fre",
        children: "Cadre d’action Éducation 2030"
      }), ", il a pour mission de suivre les progrès de l’éducation dans le cadre des ODD ainsi que ceux de l’application des stratégies nationales et internationales en matière d’éducation qui visent à aider les partenaires concernés à tenir leurs engagements."]
    }), "\n", _jsx(LinkBlock, {
      title: "Consultez le site Web",
      url: "https://fr.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "lobjectif-de-développement-durable-4",
      children: "L’Objectif de développement durable 4"
    }), "\n", _jsxs(_components.p, {
      children: ["En septembre 2015, au Sommet des Nations Unies sur le développement durable, à New York, les États membres ont officiellement adopté le ", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "Programme de développement durable à l’horizon 2030"
      }), ". Ce Programme comporte 17 objectifs, dont l’un – l’ODD 4 – vise à « assurer à tous une éducation équitable, inclusive et de qualité et des possibilités d'apprentissage tout au long de la vie ». L’ODD 4 est assorti de sept cibles et de trois modalités de mise en œuvre."]
    }), "\n", _jsx(LinkBlock, {
      title: "Voir les cibles et les cadres de suivi associés",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "Nous remercions particulièrement le Ministère fédéral allemand de l’éducation et de la recherche pour son partenariat et sa généreuse contribution à l’élaboration du site Web sur les Progrès de l’éducation."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "contactez-nous",
        children: "Contactez-nous"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Courriel général"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "L’équipe"
      }), _jsx(_components.p, {
        children: "Équipe du rapport GEM, UNESCO"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Adresse postale"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
